import React from 'react';
import { SessionFieldsFragment } from '../../../generated/core-api/graphql-react-query';
import { SessionComplianceChecklistItem } from '../SessionContext/SessionComplianceContextProvider/Hooks/useSessionCompliance/type';
import { LatestDetection } from '../SessionContext/SessionDetectionContextProvider/useSessionDetectionContext';

export interface SessionContextProps {
  sessionId: string;
  session: SessionFieldsFragment | null;
  sessionLoading: boolean;
  startSession: () => void;
  stopSession: () => void;
  context: string | null;
  setContext: React.Dispatch<React.SetStateAction<string>>;
  pinnedAt: number;
  pin: () => void;
  unpin: () => void;
  compliance: SessionComplianceChecklistItem[] | null;
  latestDetection: LatestDetection | null;
}

export const SessionContext = React.createContext<SessionContextProps | null>(null);

export default function useSessionContext() {
  const context = React.useContext(SessionContext);

  if (!context) {
    throw new Error('useSessionContext must be used within a SessionContextProvider');
  }

  return context;
}
